import React from "react";
import classNames from "classnames";
import MainLogo from "assets/logo-main.svg";
import { useHistory } from "react-router-dom";
import { AppRoutes, SystemRoutes } from "constants/routes";
import {
  useLoggedIn,
  refreshJwt,
  getResponsiveScreen,
} from "@redriver/cinnamon";
import { Button, Image, Dimmer, Segment } from "semantic-ui-react";
import LogoutLogo from "assets/enter.svg";
import { OfflineNotice } from "components/banners";
import { useSelector } from "react-redux";

const PageWrapper = ({ className, children, ...props }) => {
  const history = useHistory();
  const isLoggedIn = useLoggedIn();
  const { screenSize } = useSelector(getResponsiveScreen);
  const isViewingDashboard = [SystemRoutes.Dashboard, "/"].some(
    (x) => history.location.pathname == x
  );

  return (
    <article className={classNames("page-wrapper", className)} {...props}>
      <header>
        <div
          className={classNames("max", {
            "logged-in": isLoggedIn,
          })}
        >
          {isLoggedIn && !isViewingDashboard ? (
            <Button
              primary
              compact
              size="mini"
              onClick={() => history.goBack()}
            >
              Back
            </Button>
          ) : (
            <div />
          )}
          <img
            src={MainLogo}
            alt="Select School Travel"
            onClick={() => history.push(AppRoutes.Root)}
            style={{
              cursor: "pointer",
              height: screenSize == "small" ? 80 : "auto",
            }}
          />
          {isLoggedIn && (
            <div className="log-out">
              <Button
                primary
                compact
                size="mini"
                onClick={() => history.push(SystemRoutes.Logout)}
              >
                <Image src={LogoutLogo} />
              </Button>
            </div>
          )}
        </div>
      </header>
      <div className="page-content">
        <div className="max">{children}</div>
      </div>

      <OfflineNotice />
    </article>
  );
};

export default PageWrapper;
